<div class="phase-timeline" role="list">
  @for (phase_track_item of phase_track_items(); track phase_track_item.phase_id; let is_last = $last) {
    <div
      class="phase-timeline-step phase-illumination-{{ phase_track_item.illumination }}"
      role="listitem"
      [matTooltip]="phase_track_item.tooltip"
      matTooltipClass="phase-timeline-tooltip"
    >
      <div class="phase-timeline-node">
        @if (!is_last) {
          <span class="phase-timeline-connector" aria-hidden="true"></span>
        }
        <span class="phase-timeline-circle">
          <mat-icon aria-hidden="true">{{ phase_track_item.icon }}</mat-icon>
        </span>
        @if (phase_track_item.current_count > 0) {
          <span class="phase-timeline-badge">{{ phase_track_item.current_count }}</span>
        }
      </div>
      <p class="phase-timeline-name">{{ phase_track_item.name }}</p>
      <p class="phase-timeline-stats">{{ phase_track_item.stats_label }}</p>
    </div>
  }
</div>
